let vueInstance = new Vue()

export const eventMixin = {
  created(){
    this._event_off_list = [];
    this.$onBus = function(type, callback){
      vueInstance.$on(type, callback);
      this._event_off_list.push(()=>vueInstance.$off(type, callback));
    }
    this.$offBus = vueInstance.$off.bind(vueInstance);
    this.$emitBus = vueInstance.$emit.bind(vueInstance);
    this.$onceBus = function(type, callback){
      vueInstance.$once(type, callback);
      this._event_off_list.push(()=>vueInstance.$off(type, callback));
    }
  },
  beforeDestroy(){
    this._event_off_list.forEach(offList=>offList());
  }
}

export default vueInstance